import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const clock_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M12,4.4997 C16.143,4.4997 19.5,7.8577 19.5,11.9997 C19.5,16.1427 16.143,19.4997 12,19.4997
        C7.858,19.4997 4.5,16.1427 4.5,11.9997 C4.5,7.8577 7.858,4.4997 12,4.4997 Z M17,12.4997
        L11.5,12.4997 L11.5,6.9997"
      />
    </svg>
  );
};
